export const REACT_APP_API_URL = "https://imag-tracking-api.prod.linebot-tech.com"
export const REACT_APP_LIFF_ID = "2000061893-1oDgXwkg"
export const REACT_APP_GA_ID = "G-Z541CT4JG6"
